export default {
  unseen: 'New',
  seen: 'Earlier',
  actionRequired: 'Actions required',
  deleted: 'The notification has been deleted',
  cancel: 'Cancel',
  noNotification: 'No notification',
  delete: 'Delete',
};
